import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  ChatsByIdsRequest,
  ChatsByIdsRequestSchema,
  ChatsPageRequest,
  ChatsPageRequestSchema,
  PinChatRequest,
  PinChatRequestSchema,
  UnpinChatRequest,
  UnpinChatRequestSchema,
  PinMessagesRequest,
  PinMessagesRequestSchema,
  UnpinMessagesRequest,
  UnpinMessagesRequestSchema,
  UnpinAllMessagesRequest,
  UnpinAllMessagesRequestSchema,
  TransferOwnershipRequest,
  TransferOwnershipRequestSchema,
  AddChatParticipantsRequest,
  AddChatParticipantsRequestSchema,
  RemoveChatParticipantsRequest,
  RemoveChatParticipantsRequestSchema,
  AddChatAdminsRequest,
  AddChatAdminsRequestSchema,
  RevokeChatAdminsRequest,
  RevokeChatAdminsRequestSchema,
  UpdateChatRequest,
  UpdateChatRequestSchema,
  CreateChatRequest,
  CreateChatRequestSchema,
  GetChatUsersRequest,
  GetChatUsersRequestSchema,
  ClearChatHistoryForMeRequest,
  ClearChatHistoryForMeRequestSchema,
  ClearChatHistoryForAllRequest,
  ClearChatHistoryForAllRequestSchema,
  LeaveChatRequest,
  LeaveChatRequestSchema,
  JoinChatRequest,
  JoinChatRequestSchema,
  RemoveChatRequest,
  RemoveChatRequestSchema,
  MuteChatRequest,
  MuteChatRequestSchema,
  GetMultipleChatsEventsRequest,
  GetMultipleChatsEventsRequestSchema,
  SearchUsersForMentionRequest,
  SearchUsersForMentionRequestSchema,
  SearchUsersAddToChatRequest,
  SearchUsersAddToChatRequestSchema,
  GetUsersAddToChatRequest,
  GetUsersAddToChatRequestSchema,
  ChatsUpdatesRequest,
  ChatsUpdatesRequestSchema,
  MarkChatsAsUnreadRequest,
  MarkChatsAsUnreadRequestSchema,
  SetChatMessagesHistoryTtlRequest,
  SetChatMessagesHistoryTtlRequestSchema,
} from '../types/chat/chat_requests_pb';
import {
  ChatsByIdsResponse,
  ChatsPageResponse,
  PinChatResponse,
  UnpinChatResponse,
  PinMessagesResponse,
  UnpinMessagesResponse,
  UnpinAllMessagesResponse,
  TransferOwnershipResponse,
  AddChatParticipantsResponse,
  RemoveChatParticipantsResponse,
  AddChatAdminsResponse,
  RevokeChatAdminsResponse,
  UpdateChatResponse,
  CreateChatResponse,
  GetChatUsersResponse,
  ClearChatHistoryForMeResponse,
  ClearChatHistoryForAllResponse,
  LeaveChatResponse,
  JoinChatResponse,
  RemoveChatResponse,
  MuteChatResponse,
  GetMultipleChatsEventsResponse,
  SearchUsersForMentionResponse,
  SearchUsersAddToChatResponse,
  GetUsersAddToChatResponse,
  ChatsUpdatesResponse,
  MarkChatsAsUnreadResponse,
  SetChatMessagesHistoryTtlResponse,
} from '../types/chat/chat_responses_pb';
import {
  UserTypingMessageRequest,
  UserTypingMessageRequestSchema,
} from '../types/realtime_event/realtime_event_requests_pb';
import { UserTypingMessageResponse } from '../types/realtime_event/realtime_event_responses_pb';
import { WsRequest } from './request.types';

export function getChatsPageRequest(data: WsRequest<ChatsPageRequest>): Promise<ChatsPageResponse> {
  return wsAppRequestManager.request<ChatsPageResponse>({
    case: 'chatsPage',
    value: create(ChatsPageRequestSchema, data),
  });
}

export function getChatsByIdsRequest(
  data: WsRequest<ChatsByIdsRequest>
): Promise<ChatsByIdsResponse> {
  return wsAppRequestManager.request<ChatsByIdsResponse>({
    case: 'chatsByIds',
    value: create(ChatsByIdsRequestSchema, data),
  });
}

export function pinChatRequest(data: WsRequest<PinChatRequest>): Promise<PinChatResponse> {
  return wsAppRequestManager.request<PinChatResponse>({
    case: 'pinChat',
    value: create(PinChatRequestSchema, data),
  });
}

export function unpinChatRequest(data: WsRequest<UnpinChatRequest>): Promise<UnpinChatResponse> {
  return wsAppRequestManager.request<UnpinChatResponse>({
    case: 'unpinChat',
    value: create(UnpinChatRequestSchema, data),
  });
}

export function pinMessagesRequest(
  data: WsRequest<PinMessagesRequest>
): Promise<PinMessagesResponse> {
  return wsAppRequestManager.request<PinMessagesResponse>({
    case: 'pinMessages',
    value: create(PinMessagesRequestSchema, data),
  });
}

export function unpinMessagesRequest(
  data: WsRequest<UnpinMessagesRequest>
): Promise<UnpinMessagesResponse> {
  return wsAppRequestManager.request<UnpinMessagesResponse>({
    case: 'unpinMessages',
    value: create(UnpinMessagesRequestSchema, data),
  });
}

export function unpinAllMessagesRequest(
  data: WsRequest<UnpinAllMessagesRequest>
): Promise<UnpinAllMessagesResponse> {
  return wsAppRequestManager.request<UnpinAllMessagesResponse>({
    case: 'unpinAllMessages',
    value: create(UnpinAllMessagesRequestSchema, data),
  });
}

export function transferOwnershipRequest(
  data: WsRequest<TransferOwnershipRequest>
): Promise<TransferOwnershipResponse> {
  return wsAppRequestManager.request<TransferOwnershipResponse>({
    case: 'transferOwnership',
    value: create(TransferOwnershipRequestSchema, data),
  });
}

export function addChatParticipantsRequest(
  data: WsRequest<AddChatParticipantsRequest>
): Promise<AddChatParticipantsResponse> {
  return wsAppRequestManager.request<AddChatParticipantsResponse>({
    case: 'addChatParticipants',
    value: create(AddChatParticipantsRequestSchema, data),
  });
}

export function removeChatParticipantsRequest(
  data: WsRequest<RemoveChatParticipantsRequest>
): Promise<RemoveChatParticipantsResponse> {
  return wsAppRequestManager.request<RemoveChatParticipantsResponse>({
    case: 'removeChatParticipants',
    value: create(RemoveChatParticipantsRequestSchema, data),
  });
}

export function addChatAdminsRequest(
  data: WsRequest<AddChatAdminsRequest>
): Promise<AddChatAdminsResponse> {
  return wsAppRequestManager.request<AddChatAdminsResponse>({
    case: 'addChatAdmins',
    value: create(AddChatAdminsRequestSchema, data),
  });
}

export function revokeChatAdminsRequest(
  data: WsRequest<RevokeChatAdminsRequest>
): Promise<RevokeChatAdminsResponse> {
  return wsAppRequestManager.request<RevokeChatAdminsResponse>({
    case: 'revokeChatAdmins',
    value: create(RevokeChatAdminsRequestSchema, data),
  });
}

export function updateChatRequest(data: WsRequest<UpdateChatRequest>): Promise<UpdateChatResponse> {
  return wsAppRequestManager.request<UpdateChatResponse>({
    case: 'updateChat',
    value: create(UpdateChatRequestSchema, data),
  });
}

export function createChatRequest(data: WsRequest<CreateChatRequest>): Promise<CreateChatResponse> {
  return wsAppRequestManager.request<CreateChatResponse>({
    case: 'createChat',
    value: create(CreateChatRequestSchema, data),
  });
}

export function getChatUsersRequest(
  data: WsRequest<GetChatUsersRequest>
): Promise<GetChatUsersResponse> {
  return wsAppRequestManager.request<GetChatUsersResponse>({
    case: 'getChatUsers',
    value: create(GetChatUsersRequestSchema, data),
  });
}

export function clearChatHistoryForMeRequest(
  data: WsRequest<ClearChatHistoryForMeRequest>
): Promise<ClearChatHistoryForMeResponse> {
  return wsAppRequestManager.request<ClearChatHistoryForMeResponse>({
    case: 'clearChatHistoryForMe',
    value: create(ClearChatHistoryForMeRequestSchema, data),
  });
}

export function clearChatHistoryForAllRequest(
  data: WsRequest<ClearChatHistoryForAllRequest>
): Promise<ClearChatHistoryForAllResponse> {
  return wsAppRequestManager.request<ClearChatHistoryForAllResponse>({
    case: 'clearChatHistoryForAll',
    value: create(ClearChatHistoryForAllRequestSchema, data),
  });
}

export function leaveChatRequest(data: WsRequest<LeaveChatRequest>): Promise<LeaveChatResponse> {
  return wsAppRequestManager.request<LeaveChatResponse>({
    case: 'leaveChat',
    value: create(LeaveChatRequestSchema, data),
  });
}

export function joinChatRequest(data: WsRequest<JoinChatRequest>): Promise<JoinChatResponse> {
  return wsAppRequestManager.request<JoinChatResponse>({
    case: 'joinChat',
    value: create(JoinChatRequestSchema, data),
  });
}

export function removeChatRequest(data: WsRequest<RemoveChatRequest>): Promise<RemoveChatResponse> {
  return wsAppRequestManager.request<RemoveChatResponse>({
    case: 'removeChat',
    value: create(RemoveChatRequestSchema, data),
  });
}

export function muteChatRequest(data: WsRequest<MuteChatRequest>): Promise<MuteChatResponse> {
  return wsAppRequestManager.request<MuteChatResponse>({
    case: 'muteChat',
    value: create(MuteChatRequestSchema, data),
  });
}

export function getMultipleChatsEventsRequest(
  data: WsRequest<GetMultipleChatsEventsRequest>
): Promise<GetMultipleChatsEventsResponse> {
  return wsAppRequestManager.request<GetMultipleChatsEventsResponse>({
    case: 'getMultipleChatsEvents',
    value: create(GetMultipleChatsEventsRequestSchema, data),
  });
}

export function searchUsersForMentionRequest(
  data: WsRequest<SearchUsersForMentionRequest>
): Promise<SearchUsersForMentionResponse> {
  return wsAppRequestManager.request<SearchUsersForMentionResponse>({
    case: 'searchUsersForMention',
    value: create(SearchUsersForMentionRequestSchema, data),
  });
}

export function searchUsersAddToChatRequest(
  data: WsRequest<SearchUsersAddToChatRequest>
): Promise<SearchUsersAddToChatResponse> {
  return wsAppRequestManager.request<SearchUsersAddToChatResponse>({
    case: 'searchUsersAddToChat',
    value: create(SearchUsersAddToChatRequestSchema, data),
  });
}

export function getUsersAddToChatRequest(
  data: WsRequest<GetUsersAddToChatRequest>
): Promise<GetUsersAddToChatResponse> {
  return wsAppRequestManager.request<GetUsersAddToChatResponse>({
    case: 'getUsersAddToChat',
    value: create(GetUsersAddToChatRequestSchema, data),
  });
}

export function setUserTypingMessageRequest(
  data: WsRequest<UserTypingMessageRequest>
): Promise<UserTypingMessageResponse> {
  return wsAppRequestManager.request<UserTypingMessageResponse>({
    case: 'userTypingMessage',
    value: create(UserTypingMessageRequestSchema, data),
  });
}

export function getChatsUpdatesRequest(
  data: WsRequest<ChatsUpdatesRequest>
): Promise<ChatsUpdatesResponse> {
  return wsAppRequestManager.request<ChatsUpdatesResponse>({
    case: 'chatsUpdates',
    value: create(ChatsUpdatesRequestSchema, data),
  });
}

export function markChatsAsUnreadRequest(
  data: WsRequest<MarkChatsAsUnreadRequest>
): Promise<MarkChatsAsUnreadResponse> {
  return wsAppRequestManager.request<MarkChatsAsUnreadResponse>({
    case: 'markChatsAsUnread',
    value: create(MarkChatsAsUnreadRequestSchema, data),
  });
}

export function setChatMessagesHistoryTtlRequest(
  data: WsRequest<SetChatMessagesHistoryTtlRequest>
): Promise<SetChatMessagesHistoryTtlResponse> {
  return wsAppRequestManager.request<SetChatMessagesHistoryTtlResponse>({
    case: 'setChatMessagesHistoryTtl',
    value: create(SetChatMessagesHistoryTtlRequestSchema, data),
  });
}
